// Handle Remove Button Click
const removeButtons = [...document.querySelectorAll('cart-remove-button')];

removeButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const cartUpdate = new CustomEvent("cart:updated", {});
    document.dispatchEvent(cartUpdate);
  });
});

// Event - DOM Content Loaded
document.addEventListener("DOMContentLoaded", () => {
  init();

  document.addEventListener('Infitescroll:productsLoaded', init);
  document.addEventListener('Collection:sortingChanged', init);
});


// Init
function init() {
  const productCardCta = [...document.querySelectorAll('[js-product-card="cta"]')];
  const quantityDown = [...document.querySelectorAll('[js-grid-view="quantityDown"]')];
  const quantityUp = [...document.querySelectorAll('[js-grid-view="quantityUp"]')];

  const downloadButton = document.querySelector('[js-product="downloadButton"]');

  const cart = document.querySelector('cart-notification');

  setEventListeners();

  // Set Event Listeners
  function setEventListeners() {
    productCardCta.forEach((button) => {
      button.addEventListener("click", (event) => {
        handleCtaClick(event, cart)
      })
    });

    quantityDown.forEach((button) => {
      button.addEventListener("click", (event) => {
        handleQuantityDecrease(event)
      })
    })

    quantityUp.forEach((button) => {
      button.addEventListener("click", (event) => {
        handleQuantityIncrease(event)
      })
    })

    if (downloadButton) {
      downloadButton.addEventListener("click", (event) => {
        handleDownloadButton()
      })
    }
  }
}

// Handle Dispatch Date Change
function handleDispatchDate() {
  const cartItemsAvailability = [...document.querySelectorAll('[js-cart-item="availability"]')];
  const footerDispatch = document.querySelector('[js-cart-footer="dispatchDate"]');

  if (!cartItemsAvailability || !footerDispatch) {
    return;
  }

  let dispatchDate = "immediate"
  let immediateCount = 0;
  
  cartItemsAvailability.forEach((avilability) => {              
    const preOrderDate = avilability.dataset.preOrderDate;

    if (preOrderDate === 'immediate') {
      immediateCount += 1;
      return;
    }

    if (dispatchDate === "immediate") {
      dispatchDate = preOrderDate;
      
    } else {
      const currentLatestDate = new Date(dispatchDate);
      const newDate = new Date(preOrderDate);

      console.log(currentLatestDate)
      console.log(newDate)

      if (newDate > currentLatestDate) {
        console.log('new date > current latest date')
        dispatchDate = preOrderDate
      } else {
        console.log('new date < current latest date')
      }
    }
  });

  if (cartItemsAvailability.length === immediateCount) {
    dispatchDate = 'immediate'
  }

  if (dispatchDate === 'immediate') {
    footerDispatch.innerText = 'All items are in stock and your order can be dispatched immediately'
  } else {
    footerDispatch.innerText = `Your order will be dispatch on ${dispatchDate} once all items are available`
  }
}

// Handle Free Shipping Indicator Change
function handleFreeShippingIndicator() {
  const freeShippingIndicatorTitle = document.querySelector('[js-free-shipping-indicator="text"]');
  const freeShippingIndicatorProgress = document.querySelector('[js-free-shipping-indicator="progressBar"]');

  const subtotal = document.querySelector('.totals__subtotal-value');

  if (!subtotal) {
    return;
  }

  const formattedAmount = subtotal.innerText.split(' ')[0].replace('$', '').replace(',', '');

  if (freeShippingIndicatorTitle && freeShippingIndicatorProgress) {
    updateIndicator(freeShippingIndicatorTitle, freeShippingIndicatorProgress, formattedAmount)
  }
}

// Update Free Shipping Indicator
function updateIndicator(title, progressBar, amount) {
  const wrapper = document.querySelector('[js-free-shipping-indicator="wrapper"]');

  if (!wrapper) {
    return;
  }

  const threshold = wrapper.dataset.threshold;

  if (!threshold) {
    return;
  }
  
  title.innerText = generateAmountLeftText(amount, threshold);
  progressBar.style.width = calculateFreeShippingProgress(amount, threshold);
}

// Generate amount left to spend text for Free Shipping Indicator
function generateAmountLeftText(amount, threshold) {
  const formattedThreshold = threshold / 100
  const amountToSpend = formattedThreshold - amount;

  if (amountToSpend <= 0) {
    return 'This order qualifies for free shipping';
  }

  const formattedAmount = '$' + (amountToSpend.toFixed(2));
  const updatedTitle = 'Order another *amount* to recieve free shipping';
  return updatedTitle.replace('*amount*', formattedAmount);
}

// Calculate the progress towards recieving free shipping
function calculateFreeShippingProgress(amount, threshold) {
  const formattedThreshold = threshold / 100
  let barPercentage = (amount / formattedThreshold) * 100;
  
  if (barPercentage > 100) {
    barPercentage = 100;
  }
  
  if (barPercentage < 0) {
    barPercentage = 0;
  }

  return `${barPercentage}%`;
}

// Product Card - Handle Variant Selector Change
function handleVariantSelectorChange(event) {
  const productCard = event.target.closest('[js-product-card="card"]');
  const variantId = event.target.value;

  if (productCard) {
    return;
  }

  const handle = productCard.dataset.handle;
  const productCardCta = productCard.querySelector('[js-product-card="cta"]');

  if (!handle && !productCardCta) {
    return;
  }

  fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .then((data) => {
      const variantIndex = data?.variants.findIndex(variant => variant.id == variantId);

      if (variantIndex >= 0) {
        productCardCta.disabled = !data.variants[variantIndex].available;
        data.variants[variantIndex].available ? productCardCta.innerText = 'Add to Cart' : productCardCta.innerText = 'Sold Out';
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

// Product Card - Handle CTA Click
function handleCtaClick(event, cart) {
  const variantWrapper = event.target.closest('[js-product-card="variantWrapper"]');
  const productCard = event.target.closest('[js-product-card="card"]');
    
  let id = event.target.dataset.id;
  let quantity = 1;
  
  if (variantWrapper) {
    const quantityInput = variantWrapper.querySelector('[js-grid-view="quantityInput"]');

    if (quantityInput) {
      quantity = quantityInput.value;
    }
  }

  if (!id) {
    return;
  }

  addToCart(id, quantity, productCard, cart);
}

function handleQuantityDecrease(event) {
  const quantityWrapper = event.target.closest('[js-grid-view="quantityWrapper"]');

  if (!quantityWrapper) {
    return;
  }
  
  const quantityInput = quantityWrapper.querySelector('[js-grid-view="quantityInput"]');

  if (!quantityInput) {
    return;
  }
  
  const inputValue = Number(quantityInput.value);
  const inputStep = Number(quantityInput.step);
  const inputMin = Number(quantityInput.min);

  const newValue = inputValue - inputStep;

  if (newValue < inputMin) {
    return;
  }

  quantityInput.value = newValue;
}

function handleQuantityIncrease(event) {
  const quantityWrapper = event.target.closest('[js-grid-view="quantityWrapper"]');

  if (!quantityWrapper) {
    return;
  }
  
  const quantityInput = quantityWrapper.querySelector('[js-grid-view="quantityInput"]');

  if (!quantityInput) {
    return;
  }
  
  const inputValue = Number(quantityInput.value);
  const inputStep = Number(quantityInput.step);

  const newValue = inputValue + inputStep;

  quantityInput.value = newValue;
}

// Download all of products media
function handleDownloadButton() {
  const media = [...document.querySelectorAll('.product__media-item.grid__item')];
  const productTitle = document.querySelector('[js-product="productTitle"]');
  let fileName = 'images'

  if (!media) {
    return;
  }

  if (productTitle) {
    fileName = productTitle.innerText;
    fileName = fileName.replace(' ', '-');
  }

  media.forEach((item) => {
    const mediaTypeImage = item.querySelector('.media-type-image');

    if (!mediaTypeImage) {
      return;
    }
    
    const image = item.querySelector('img');
    // const template = item.querySelector('template'); 

    if (image) {
      downloadImage(image.src, fileName);
    }

    // if (template) {
    //   const video = template.content.firstElementChild.cloneNode(true);

    //   if (video.tagName === 'VIDEO') {
    //     const source = video.querySelector('source');
    //     downloadVideo(source.src, fileName);
    //     return;
    //   } 
      
    //   if (video.tagName === 'IFRAME') {
    //     if (video.src.includes('youtube') || video.src.includes('youtu.be')) {
    //       downloadYouTubeVideo(video.src, fileName);
    //       return;
    //     }

    //      if (video.src.includes('vimeo')) {
    //       downloadVimeoVideo(video.src, fileName);
    //     }
    //   }
    // }
    
  })
}

// Downloads the image from the src passed in as a param
async function downloadImage(imageSrc, fileName) {
  const image = await fetch(imageSrc)
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)

  const link = document.createElement('a')
  link.href = imageURL
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// async function downloadVideo(videoSrc, fileName) {
//   try {
//     const response = await fetch(videoSrc);
//     const videoBlob = await response.blob();
  
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(videoBlob);
//     link.download = `${fileName}.mp4`
  
//     link.click();
//     URL.revokeObjectURL(link.href);
//     link.remove();
//   } catch (error) {
//     console.error('An error occurred while downloading the video:', error);
//   }
// }

// function downloadVimeoVideo(videoUrl, fileName) {
//   const videoId = extractVimeoVideoId(videoUrl);

//   // Retrieve video metadata from the Vimeo API
//   fetch(`https://vimeo.com/api/oembed.json?url=https%3A%2F%2Fvimeo.com%2F${videoId}`)
//     .then(response => response.json())
//     .then(data => {
//       const downloadUrl = data.video_files[0].download_link;

//       // Create a temporary link and trigger the download
//       const link = document.createElement('a');
//       link.href = downloadUrl;
//       link.download = `video-vimeo-${fileName}.mp4`;
//       link.style.display = 'none';

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     })
//     .catch(error => {
//       console.error('An error occurred while fetching video information:', error);
//     });
// }

// function downloadYouTubeVideo(videoUrl, fileName) {
//   const videoId = extractYouTubeVideoId(videoUrl);
//   const downloadUrl = `https://www.youtube.com/watch?v=${videoId}`;

//   const link = document.createElement('a');
//   link.href = downloadUrl;
//   link.download = `video-youtube-${fileName}.mp4`;
//   link.style.display = 'none';

//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

// function extractYouTubeVideoId(videoUrl) {
//   const regex = /[?&]v=([^&#]*)/;
//   const match = videoUrl.match(regex);
//   return match && match[1] ? match[1] : '';
// }

// function extractVimeoVideoId(videoUrl) {
//   const regex = /\/(\d+)$/;
//   const match = videoUrl.match(regex);
//   return match && match[1] ? match[1] : '';
// }

// Add ID and Quantity to cart
function addToCart(id, quantity, productCard, cart) {
  const formData = {
    'items': [{
    'id': id,
    'quantity': quantity
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((data) => {
    if (data.items) {
      cart.renderContents(data.items[0]);

      // SH Update
      document.documentElement.dispatchEvent(new Event('sh:cart:change', { bubbles: true }));
      
      return;
    }

    const error = productCard.querySelector('[js-product-card="error"]');

    if (data.message == 'Cart Error' && error) {
      error.innerText = data.description;
      error.classList.remove('is-hidden');
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}